module.exports = __webpack_public_path__ + "static/screen-3@2x-3218236d85c367c8630eb92f9102dbe8.png";